module.exports = "/pages/business/hotelslabo/first_view_image_pc.png";